import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ } from "@/constants/testIds";

const faqs = [
  { q: "È adatto agli studenti delle superiori?", a: "Assolutamente sì. ComprehensionUp è pensato per studenti dai 16 ai 40 anni, dalle scuole superiori fino all'università. Il linguaggio è chiaro e il metodo si applica a qualsiasi materia." },
  { q: "Come ricevo il manuale dopo l'acquisto?", a: "Il download è immediato. Appena completi l'ordine ti compare il pulsante per scaricare subito il PDF, senza attese e senza bisogno di creare un account." },
  { q: "In che formato è il manuale?", a: "È un file PDF di 31 pagine, leggibile su computer, tablet e smartphone. Puoi anche stamparlo e compilare direttamente gli esercizi guidati." },
  { q: "Devo già essere bravo a studiare per usarlo?", a: "No. Non si tratta di partire da zero, ma di fare meglio ciò che già fai. Il processo in 4 fasi migliora le tue abitudini di studio, qualunque sia il tuo punto di partenza." },
  { q: "Quanto tempo serve per vedere i risultati?", a: "Il valore non è nel leggere la guida, ma nell'usare il processo sui tuoi testi reali. Molti studenti notano una differenza già dopo le prime sessioni di studio guidato." },
  { q: "È un pagamento unico o un abbonamento?", a: "È un pagamento unico di €12,90 (invece di €29,90) con accesso a vita al manuale. Nessun abbonamento, nessun costo nascosto." },
];

export default function Faq() {
  return (
    <section id="faq" data-testid={FAQ.section} className="relative py-16 sm:py-24 lg:py-28 bg-white">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center mb-10">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5982c5]">Domande frequenti</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#1f2937]">
            Hai ancora dei dubbi?
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={FAQ.item(i)}
              className="bg-[#ecfef7] rounded-2xl border border-[#5982c5]/10 px-5 sm:px-6"
            >
              <AccordionTrigger className="text-left font-heading font-semibold text-[#1f2937] hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#4b5563] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
